<header class="header">
  {{ dialogData?.title }}
</header>

<mt-divider></mt-divider>

<form
  class="form"
  [formGroup]="form">
  <mt-field>
    <label
      required
      for="reason">
      {{ 'GENERAL.REASON' | translate }}
    </label>
    <mt-textarea
      [id]="'reason'"
      formControlName="reason">
    </mt-textarea>
    <mt-comment
      styledSeverity="severity-error"
      [controlStateToError]="form.controls.reason">
    </mt-comment>
  </mt-field>
</form>

<mt-divider></mt-divider>

<footer class="footer">
  <mt-button
    [title]="'GENERAL.NO_CANCEL' | translate"
    [styledSeverity]="'severity-secondary'"
    (OnClick)="cancel()">
  </mt-button>
  <mt-button
    [title]="'GENERAL.CONFIRM' | translate"
    [styledEmphasis]="'emphasis-filled'"
    [disabled]="form.invalid"
    (OnClick)="apply()">
  </mt-button>
</footer>
